import { EXCHANGE_POLICY_ENUM } from ".";

const _ = require('lodash'); // 引入Lodash库

export enum COUPON_TYPE {
    CASH_COUPON = 'CASH_COUPON',
    EXCHANGE_VOUCHER = 'EXCHANGE_VOUCHER',
    REPRICE_COUPON = 'REPRICE_COUPON',
    ANY_VOUCHER = 'ANY_VOUCHER',
    DISCOUNT_COUPON = 'DISCOUNT_COUPON',
    NONE = 'NONE',
}
/**
 * @desc COUPON_DISPOSITION_KEY 优惠券的默认配置信息
 * @DISCOUNTVALUE 限额、多少以下可用
 * @LINMITVALUE 低消费、比如满多少可用？
 * @COMPENSATEPRICE 是否可补差价
 * @SCOPE 作用范围？订单｜（单票/单卖品）
 * @EXCHANGEQUANTITY 几兑1
 * @isOneTemplate 是否需要券模版相同
 */
export enum COUPON_DISPOSITION_KEY {
    DISCOUNTVALUE = 'defaultDiscountValue',
    LINMITVALUE = 'defaultLimitValue',
    COMPENSATEPRICE = 'defaultCompensatePrice',
    SCOPE = 'scope',
    EXCHANGEQUANTITY = 'defaultExchangeQuantity',
    isOneTemplate = 'isOneTemplate'
}


// 为 COUPON_DISPOSITION_KEY 每个键映射对应的类型
interface CouponDispositionValueTypes {
    [COUPON_DISPOSITION_KEY.DISCOUNTVALUE]: number;
    [COUPON_DISPOSITION_KEY.LINMITVALUE]: number;
    [COUPON_DISPOSITION_KEY.COMPENSATEPRICE]: 'Y' | 'N'
    [COUPON_DISPOSITION_KEY.SCOPE]: 'order' | 'sku';
    [COUPON_DISPOSITION_KEY.EXCHANGEQUANTITY]: number;
    [COUPON_DISPOSITION_KEY.isOneTemplate]: Boolean;
}
type CouponTypesWithoutNone = Exclude<COUPON_TYPE, COUPON_TYPE.NONE>;
type CouponConfig = {
    [K in CouponTypesWithoutNone]: {
        [J in keyof CouponDispositionValueTypes]: CouponDispositionValueTypes[J];
    }
};


export const couponDisposition: CouponConfig = {
    //代金券
    [COUPON_TYPE.CASH_COUPON]: {
        [COUPON_DISPOSITION_KEY.DISCOUNTVALUE]: 9999999999, //限额
        [COUPON_DISPOSITION_KEY.LINMITVALUE]: 0, //低消
        [COUPON_DISPOSITION_KEY.COMPENSATEPRICE]: 'Y', //是否可补差价
        [COUPON_DISPOSITION_KEY.SCOPE]: 'order', //作用于订单还是单品
        [COUPON_DISPOSITION_KEY.EXCHANGEQUANTITY]: 1, //几兑1
        [COUPON_DISPOSITION_KEY.isOneTemplate]: false, //是否验证券模版
    },
    //普通兑换券
    [COUPON_TYPE.EXCHANGE_VOUCHER]: {
        [COUPON_DISPOSITION_KEY.DISCOUNTVALUE]: 9999999999,
        [COUPON_DISPOSITION_KEY.LINMITVALUE]: 0,
        [COUPON_DISPOSITION_KEY.COMPENSATEPRICE]: 'Y',
        [COUPON_DISPOSITION_KEY.SCOPE]: 'sku',
        [COUPON_DISPOSITION_KEY.EXCHANGEQUANTITY]: 1,
        [COUPON_DISPOSITION_KEY.isOneTemplate]: false,
    },
    //定价券
    [COUPON_TYPE.REPRICE_COUPON]: {
        [COUPON_DISPOSITION_KEY.DISCOUNTVALUE]: 9999999999,
        [COUPON_DISPOSITION_KEY.LINMITVALUE]: 0,
        [COUPON_DISPOSITION_KEY.COMPENSATEPRICE]: 'Y',
        [COUPON_DISPOSITION_KEY.SCOPE]: 'sku',
        [COUPON_DISPOSITION_KEY.EXCHANGEQUANTITY]: 1,
        [COUPON_DISPOSITION_KEY.isOneTemplate]: false,
    },
    // 自定义兑换券
    [COUPON_TYPE.ANY_VOUCHER]: {
        [COUPON_DISPOSITION_KEY.DISCOUNTVALUE]: 9999999999,
        [COUPON_DISPOSITION_KEY.LINMITVALUE]: 0,
        [COUPON_DISPOSITION_KEY.COMPENSATEPRICE]: 'Y',
        [COUPON_DISPOSITION_KEY.SCOPE]: 'sku',
        [COUPON_DISPOSITION_KEY.EXCHANGEQUANTITY]: 1,
        [COUPON_DISPOSITION_KEY.isOneTemplate]: true,
    },
    //折扣券
    [COUPON_TYPE.DISCOUNT_COUPON]: {
        [COUPON_DISPOSITION_KEY.DISCOUNTVALUE]: 9999999999,
        [COUPON_DISPOSITION_KEY.LINMITVALUE]: 0,
        [COUPON_DISPOSITION_KEY.COMPENSATEPRICE]: 'Y',
        [COUPON_DISPOSITION_KEY.SCOPE]: 'sku',
        [COUPON_DISPOSITION_KEY.EXCHANGEQUANTITY]: 1,
        [COUPON_DISPOSITION_KEY.isOneTemplate]: false,
    },
}

export const couponGroupMap = [
    [COUPON_TYPE.CASH_COUPON],
    [COUPON_TYPE.EXCHANGE_VOUCHER],
    [COUPON_TYPE.REPRICE_COUPON],
    [COUPON_TYPE.ANY_VOUCHER],
    [COUPON_TYPE.DISCOUNT_COUPON],
    // [COUPON_TYPE.DISCOUNT_COUPON,COUPON_TYPE.CASH_COUPON],
]

export const packCouponList = (list) => {
    const resList = _.cloneDeep(list)
    const getCouPonType = (item) => {

        if (item.couponType === COUPON_TYPE.EXCHANGE_VOUCHER) {
            //兑换券 有普通1兑1，和自定义N对1
            if (item.exchangePolicy === EXCHANGE_POLICY_ENUM.ONE) {
                return COUPON_TYPE.EXCHANGE_VOUCHER
            } else if (item.exchangePolicy === EXCHANGE_POLICY_ENUM.CUSTOM) {
                // debugger
                return COUPON_TYPE.ANY_VOUCHER
            }else{
                return COUPON_TYPE.EXCHANGE_VOUCHER
            }
        } else {
            return item.couponType
        }
    }
    return resList.map(item => {
        const { discountValue, compensatePrice, exchangeQuantity, limitValue } = item
        const couponType = getCouPonType(item)
        const res = {
            ...item,
            curCouponType: item.couponType, //原来的类型
            couponType: couponType, //计算用的类型
            discountValue: discountValue ?? couponDisposition[couponType][COUPON_DISPOSITION_KEY.DISCOUNTVALUE],
            compensatePrice: compensatePrice ?? couponDisposition[couponType][COUPON_DISPOSITION_KEY.COMPENSATEPRICE],
            exchangeQuantity: exchangeQuantity ?? couponDisposition[couponType][COUPON_DISPOSITION_KEY.EXCHANGEQUANTITY],
            limitValue: limitValue ?? couponDisposition[couponType][COUPON_DISPOSITION_KEY.LINMITVALUE],
            isOneTemplate: couponDisposition[couponType][COUPON_DISPOSITION_KEY.isOneTemplate],
            scope: couponDisposition[couponType][COUPON_DISPOSITION_KEY.SCOPE],
        }
        // console.log('[dev]看看-res:', res);
        return res
    })
}


export const getInCouponGroupMap = (list: COUPON_TYPE[]): boolean => {
    return couponGroupMap.findIndex(item => { return _.isEqual(item, list) }) > -1
}

export const packTikectDiscountMap = (list) => {
    const res = _.cloneDeep(list.map(i => {
        return {
            seatName: i.seatNumber || i.seatName,
            price: i.areaPrice,
            useCoupon: []
        }
    }).sort((a, b) => { return Number(a.price) > Number(b.price) ? 1 : 0 }))
    return res
}

export const packGoodsDiscountMap = (list) => {
    const cur = _.cloneDeep(list)
    let res: any[] = []
    cur?.forEach(item => {
        const { goodsName, goodsId, number, price, standardPrice } = item
        for (let index = 0; index < number; index++) {
            const element = {
                goodsName,
                goodsId,
                price: Number(standardPrice),
                useCoupon: []
            }
            res.push(element)

        }
    })
    return res.sort((a, b) => { return Number(a.price) > Number(b.price) ? 1 : 0 })
}